module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Semibold-9d83d6a8.eot";